import { BiPlus } from "react-icons/bi"
import BotaoCadastro from "../../Forms/BotaoCadastro"
import style from "./professores.module.css"
import { useEffect, useState } from "react"
import { FormProfessor } from "../../Forms/Cadastro"
import { getDocCollection, getItens } from "../../../firebase/CRUD"
import { FichaProfessor } from "../../layout/Fichas"
import { useAuth } from "../../../hooks/AuthContext"
import ContainerLista from '../../layout/ContainerLista/ContainerLista'
import ProfessorAdd from "./ProfessorAdd"
import CardProfessor from "./CardProfessor"

export default function Professores(){
    const {usuario} = useAuth()
    const [Professores,setProfessores] = useState([])
    const [cadastramento,setCadastramento] = useState(false)

    useEffect(()=>{
        return getItens("professores",setProfessores,usuario.idEscola)
    },[])

    const ativarCadastramento = ()=>{
        setCadastramento(true)
    }
    const desativarCadastramento = ()=>{
        setCadastramento(false)
    }

    return(
        <div style={{width:'100%'}}>
           
            <ContainerLista itensLista={Professores} pagina={'Professores'} cadastramento={ativarCadastramento}>
                {Professores.length > 0 && 
                Professores.map((item,id)=>
                    <CardProfessor
                        key={item.id}
                        professor={item}
                    />
                )}
            </ContainerLista>
            
            {cadastramento && <ProfessorAdd cadastramento={desativarCadastramento}/>} 
                     
        </div>
    )
}